"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FILTERS_GROUP_LOCKED = exports.FILTER_TYPES = exports.FILTER_GROUPS = void 0;

var _immutable = require("immutable");

var _Operators = require("./Operators");

var _Scopes = require("lead-flows-ui/constants/Scopes");

var FILTER_GROUPS = {
  URL: 'url',
  LOCATION: 'location',
  LANGUAGE: 'language',
  DEVICE: 'device',
  BEHAVIOR: 'behavior'
};
exports.FILTER_GROUPS = FILTER_GROUPS;
var FILTER_TYPES = {
  TEXT: 'text',
  NUMBER: 'number',
  QUERY_PARAM: 'queryParameter',
  OPERATING_SYSTEM: 'operatingSystem',
  DEVICE_TYPE: 'deviceType',
  TOPIC: 'topic',
  TOPIC_HISTORY: 'topicHistory',
  TIME_SINCE_LAST_VISIT: 'timeSinceLastVisit',
  LANGUAGE: 'language',
  COUNTRY: 'country',
  CTA_CLICKS: 'ctaClick',
  FORM_VIEW: 'formView'
};
exports.FILTER_TYPES = FILTER_TYPES;
var FILTERS_GROUP_LOCKED = [FILTER_GROUPS.URL];
exports.FILTERS_GROUP_LOCKED = FILTERS_GROUP_LOCKED;
var _default = {
  DEVICE: {
    key: 'deviceType',
    group: FILTER_GROUPS.DEVICE,
    operators: [_Operators.CONTAINS_ANY],
    type: FILTER_TYPES.DEVICE_TYPE,
    groupLock: null,
    addOperator: false
  },
  BROWSER_LANGUAGE: {
    key: 'language',
    group: FILTER_GROUPS.LANGUAGE,
    operators: [_Operators.CONTAINS_ANY],
    type: FILTER_TYPES.LANGUAGE,
    groupLock: null,
    addOperator: false
  },
  COUNTRY: {
    key: 'country',
    group: FILTER_GROUPS.LOCATION,
    operators: [_Operators.CONTAINS_ANY],
    type: FILTER_TYPES.COUNTRY,
    groupLock: null,
    addOperator: false
  },
  URL: {
    key: 'url',
    group: FILTER_GROUPS.URL,
    operators: [_Operators.EQ, _Operators.CONTAINS, _Operators.STR_STARTS_WITH],
    type: FILTER_TYPES.TEXT,
    groupLock: 'always',
    addOperator: true,
    requiredScope: _Scopes.AUDIENCE_TARGETING_ESSENTIAL_RULES,
    defaultValue: ''
  },
  QUERY_PARAM: {
    key: 'queryParameter',
    group: FILTER_GROUPS.URL,
    operators: [_Operators.EQ],
    type: FILTER_TYPES.QUERY_PARAM,
    groupLock: 'always',
    addOperator: true,
    requiredScope: _Scopes.AUDIENCE_TARGETING_ESSENTIAL_RULES,
    defaultValue: {
      name: '',
      value: ''
    }
  },
  // IP: {
  //   key: 'ip',
  //   group: FILTER_GROUPS.LOCATION,
  //   operators: [CONTAINS_ANY],
  //   type: FILTER_TYPES.MULTI,
  //   addOperator: false,
  //   defaultValue: '',
  // },
  // OPERATING_SYSTEM: {
  //   key: 'operatingSystem',
  //   group: FILTER_GROUPS.DEVICE,
  //   operators: [CONTAINS_ANY],
  //   type: FILTER_TYPES.OPERATING_SYSTEM,
  //   groupLock: null,
  //   addOperator: false,
  //   defaultValue: '',
  // },
  CTA_CLICKS: {
    key: 'ctaClick',
    group: FILTER_GROUPS.BEHAVIOR,
    operators: [_Operators.CONTAINS_ANY],
    type: FILTER_TYPES.CTA_CLICKS,
    groupLock: null,
    addOperator: false,
    requiredScope: _Scopes.AUDIENCE_TARGETING_ADVANCED_RULES,
    defaultValue: ''
  },
  TIME_SINCE_LAST_VISIT: {
    key: 'timeSinceLastVisit',
    group: FILTER_GROUPS.BEHAVIOR,
    operators: [_Operators.GT, _Operators.LT],
    type: FILTER_TYPES.TIME_SINCE_LAST_VISIT,
    groupLock: null,
    addOperator: false,
    requiredScope: _Scopes.AUDIENCE_TARGETING_ADVANCED_RULES,
    defaultValue: ''
  },
  FORM_VIEW: {
    key: 'formView',
    group: FILTER_GROUPS.BEHAVIOR,
    operators: [_Operators.CONTAINS_ANY],
    type: FILTER_TYPES.FORM_VIEW,
    groupLock: null,
    addOperator: false,
    requiredScope: _Scopes.AUDIENCE_TARGETING_ADVANCED_RULES,
    defaultValue: new _immutable.List([])
  },
  SESSION_COUNT: {
    key: 'sessionCount',
    group: FILTER_GROUPS.BEHAVIOR,
    operators: [_Operators.EQ, _Operators.GT, _Operators.LT],
    type: FILTER_TYPES.NUMBER,
    groupLock: null,
    addOperator: false,
    requiredScope: _Scopes.AUDIENCE_TARGETING_ADVANCED_RULES,
    defaultValue: new _immutable.List([])
  },
  PAGE_VISITS: {
    key: 'pageVisits',
    group: FILTER_GROUPS.BEHAVIOR,
    operators: [_Operators.EQ, _Operators.CONTAINS, _Operators.STR_STARTS_WITH],
    type: FILTER_TYPES.TEXT,
    groupLock: null,
    addOperator: true,
    requiredScope: _Scopes.AUDIENCE_TARGETING_ADVANCED_RULES,
    defaultValue: ''
  },
  REFERRER: {
    key: 'referrer',
    group: FILTER_GROUPS.BEHAVIOR,
    operators: [_Operators.EQ, _Operators.CONTAINS, _Operators.STR_STARTS_WITH],
    type: FILTER_TYPES.TEXT,
    groupLock: 'filter',
    addOperator: true
  },
  TOPIC: {
    key: 'topic',
    group: FILTER_GROUPS.BEHAVIOR,
    operators: [_Operators.CONTAINS_ANY],
    type: FILTER_TYPES.TOPIC,
    groupLock: null,
    addOperator: false,
    requiredScope: _Scopes.AUDIENCE_TARGETING_ADVANCED_RULES,
    defaultValue: new _immutable.List([])
  },
  TOPIC_HISTORY: {
    key: 'topicHistory',
    group: FILTER_GROUPS.BEHAVIOR,
    operators: [_Operators.CONTAINS_ANY],
    type: FILTER_TYPES.TOPIC_HISTORY,
    groupLock: null,
    addOperator: false,
    requiredScope: _Scopes.AUDIENCE_TARGETING_ADVANCED_RULES,
    defaultValue: new _immutable.List([])
  },
  LIST_MEMBERSHIP: {
    key: 'listMembership',
    group: FILTER_GROUPS.BEHAVIOR,
    operators: [_Operators.EQ],
    type: FILTER_TYPES.LIST_MEMBERSHIP,
    groupLock: null,
    addOperator: false,
    requiredScope: _Scopes.AUDIENCE_TARGETING_ADVANCED_RULES,
    defaultValue: new _immutable.List([])
  },
  CONTACT: {
    key: 'contact',
    group: FILTER_GROUPS.BEHAVIOR,
    operators: [_Operators.EQ],
    type: FILTER_TYPES.CONTACT,
    groupLock: null,
    addOperator: false,
    requiredScope: _Scopes.AUDIENCE_TARGETING_ADVANCED_RULES,
    defaultValue: true
  }
};
exports.default = _default;